module.exports = __webpack_public_path__ + "static/7-HUMAN-EXPERIENCE-DESIGN-8e76df798ee11da479104b1574a8898a.png";